import React, { useEffect, useState } from "react";
import Button from "../Button/Button";

import { ChatWriterStyle } from "./ChatWriterStyle";
import { GrAttachment } from "react-icons/gr";
import { useAnswerTicketByAdmin } from "../../hooks/useManagement";
import { errorMessage } from "../../utils/message";
const initvalue = {
  ticket_id: null,
  content: null,
  file: null,
};
const ChatWriter = ({ data, setChatInfo, chatInfo, submit }) => {
  const [form, setForm] = useState(initvalue);
  const { mutateAsync: SendTicket, isLoading: sendingTicket } =
    useAnswerTicketByAdmin();

  const validateForm = () => {
    if (form.content.length < 1) {
      errorMessage("لطفا جواب تیکت را بنویسید");
      return false;
    }
    return true;
  };

  const handleAnswerTicket = async () => {
    if (validateForm()) {
      const formdata = new FormData();
      if (form.file) {
        formdata.append("file", form.file);
      }
      formdata.append("ticket_id", form.ticket_id);
      formdata.append("content", form.content);
      await SendTicket(formdata).then(setForm({ ...form, content: "" }));
    }
  };

  useEffect(() => {
    setForm({ ...form, ticket_id: data?.data?.Ticket?.IdTicket });
  }, [data]);
  return (
    <ChatWriterStyle className="row">
      <div className="input col-lg-10 col-md-0 col-sm-9 col-8 d-flex">
        <textarea
          name=""
          id=""
          rows="1"
          className="w-100"
          placeholder="متن  خود را اینجا بنویسید"
          onChange={(e) => {
            setForm({ ...form, content: e.target.value });
          }}
          onKeyUp={(e) => {
            if (chatInfo) {
              setChatInfo({ ...chatInfo, text: form?.content });
            }
          }}
          value={!chatInfo ? form?.content : chatInfo?.text}
        ></textarea>
      </div>
      <div className=" button col-lg-2 col-md-3 col-sm-3 col-4 d-flex ">
        <Button
          bgColor="#009ef7"
          small="fit-content"
          color="#fff"
          className="m-0"
          onclick={(event) => {
            if (!chatInfo) {
              handleAnswerTicket();
              setForm({ ...form, file: null, content: "" });
            } else {
              submit();
              setChatInfo({ ...chatInfo, file: null, text: "" });
            }
          }}
          // onclick={()=>chatinfo}
        >
          {!sendingTicket ? "ارسال" : "در حال ارسال..."}
        </Button>
        <div className="file">
          <label htmlFor="input-file">
            <GrAttachment />
          </label>
          <input
            id="input-file"
            type="file"
            onChange={(e) => {
              if (!chatInfo) {
                setForm({ ...form, file: e.target.files[0] });
              } else {
                setChatInfo({ ...chatInfo, file: e.target.files[0] });
              }
            }}
          />
        </div>
        {form?.file || chatInfo?.file ? (
          <Button
            small="fit-content"
            size="12px"
            bgColor="#f1416c"
            color="#fff"
            className="m-0 me-2"
            onclick={() => {
              setForm({ ...form, file: null });
              setChatInfo({ ...chatInfo, file: null });
            }}
          >
            حذف فایل
          </Button>
        ) : (
          ""
        )}
      </div>
    </ChatWriterStyle>
  );
};

export default ChatWriter;
